import type { CharacterStay } from "@/data/rail-branches";

const staysByCharacter = new WeakMap<
  readonly CharacterStay[],
  ReadonlyMap<string, readonly CharacterStay[]>
>();

/** A loaded book's stays never change, so each person's list is built once. */
export function staysOf(
  stays: readonly CharacterStay[],
  characterId: string,
): readonly CharacterStay[] {
  let index = staysByCharacter.get(stays);
  if (index === undefined) {
    const built = new Map<string, CharacterStay[]>();
    for (const stay of stays) {
      const own = built.get(stay.characterId);
      if (own === undefined) {
        built.set(stay.characterId, [stay]);
      } else {
        own.push(stay);
      }
    }
    index = built;
    staysByCharacter.set(stays, index);
  }
  return index.get(characterId) ?? [];
}

export function stayAt(
  stays: readonly CharacterStay[],
  characterId: string,
  playheadMs: number,
): CharacterStay | undefined {
  const matches = staysOf(stays, characterId).filter(
    (stay) => playheadMs >= stay.startMs && playheadMs <= stay.endMs,
  );
  return matches.find((stay) => stay.startMs === playheadMs) ?? matches[0];
}
